import { createResource, type RouteResource } from '@atlassian/react-resource-router';

const MIN_MAX_AGE: number = 5 * 1000;

const RESOURCE_TYPE_PROJECTS_COMPONENTS = 'PROJECTS_COMPONENTS';

// oxlint-disable-next-line @typescript-eslint/no-explicit-any
export const projectsComponentsResource: RouteResource<any> = createResource<any>({
	type: RESOURCE_TYPE_PROJECTS_COMPONENTS,
	getKey: () => 'state',
	getDataLoader: () =>
		import(
			/* webpackChunkName: "async-resource-projects-components", jiraSpaEntry: "async-resource-projects-components" */ './getData.tsx'
		),
	maxAge: MIN_MAX_AGE,
});
